export default "__VITE_ASSET__MB5jTQZo__"